import surah from '../data/surah.json';
export function getChapterName(number) {
    return surah[number - 1];
}
